import { TJsonQueryRequiredKeys, TJsonQueryOptionalKeys } from '../../packages/JsonQuery';

export const COMMON_PROPERTIES: (TJsonQueryRequiredKeys | TJsonQueryOptionalKeys)[] = [
  '_type',
  'beds_count',
  'builders_ids',
  'builder',
  'currency',
  'dates',
  'engine_version',
  'for_day',
  'geo',
  'kp_id',
  'object_type',
  'office_type',
  'region',
  'is_early_access_enabled',
  'price',
  'price_sm',
  'price_type',
  'total_area',
  'workplace_count',
  'category',
  'coworking_offer_type',
  'ready_business_types',
  'is_by_commercial_owner',
  'specialty_types',
];

export const COMMON_PROPERTIES_SUBURBAN: (TJsonQueryRequiredKeys | TJsonQueryOptionalKeys)[] = [
  '_type',
  'beds_count',
  'building_status',
  'currency',
  'dates',
  'engine_version',
  'for_day',
  'from_developer',
  'geo',
  'kp_id',
  'object_type',
  'price',
  'price_sm',
  'region',
  'room',
  'site',
  'total_area',
  'village_mortgage_allowed',
  'with_newobject',
];
